import { gql } from '@apollo/client';

import { SITE_SECTION_FRAGMENT } from '@/queries/Preview';
import { SitePage } from '@/types/SitePage';
import { UserErrors } from '@/types/UserErrors';

export const SaveSitePage = gql`
  mutation SaveSitePage($input: SaveSitePageInput!) {
    saveSitePage(input: $input) {
      sitePage {
        id
        name
        pageType
        status
        slug
        landingPageUrl
        siteSections {
          nodes {
            ...SiteSectionFields
          }
        }
      }
      userErrors {
        code
        message
        path
      }
    }
  }

  ${SITE_SECTION_FRAGMENT}
`;

export type SaveSitePageMutationData = {
  saveSitePage: {
    sitePage: Pick<
      NonNullable<SitePage>,
      | 'id'
      | 'name'
      | 'pageType'
      | 'status'
      | 'slug'
      | 'landingPageUrl'
      | 'siteSections'
    > | null;
    userErrors: UserErrors;
  };
};

export type SaveSitePageMutationVariables = {
  input: {};
};
